import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Button from 'b2b-ui-components-lib/lib/components/button';
import errorIcon from '../../../assests/error.png';
import './Failure.scss';
import { findParamFromUrl, removeUserSessionData } from 'common/utils/app.utils';
import appConfig from '../../../config/config';
import { AppContext } from 'App';

const Failure = () => {
  const { showSteps } = useContext(AppContext);
  const partyId = findParamFromUrl('partyId', false);
  const location = useLocation();
  const [message, setMessage] = useState({
    title: 'Sorry! The order confirmation link has expired.',
    body: 'Your order confirmation link has expired.'
  });

  useEffect(() => {
    if (location?.state) {
      const { title, body } = location.state;
      setMessage({ title, body });
    }

    console.log(location.state);
  }, [location]);

  useEffect(() => {
    showSteps && showSteps(false);
    removeUserSessionData();
  }, []);
  return (
    <div className="failure_box">
      <div className="container">
        <div className="box_content">
          <div className="message_container">
            <h2 className="message_title">
              <img src={errorIcon} className="error_image" /> {message.title}{' '}
            </h2>
            <p className="message_content"> {message.body} </p>
            <span className="description">
              Should you have any queries regarding cancellation or extension of service, write to us at
              <a href="mailto:enterprise.request@airtel.com" className="mail-url">
                {' '}
                enterprise.request@airtel.com
              </a>{' '}
              copying your Account Manager and Relationship Manager.
            </span>
            <div className="button_action">
              <a className="track-link" href={partyId ? appConfig.kamTrackLeadPage + '?partyId=' + partyId : appConfig.kamTrackLeadPage}>
                <Button displayName="Track Order" />
              </a>
              <a href={appConfig.aehdashboardUrl}>
                <Button displayName="Go Back To Home" variant="outlinebtn" buttonClass="outline-btn" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Failure;
